const APP_ID = '582759f2-4119-4341-8c31-a0689df714c7'
const SAFARI_WEB_ID = 'web.onesignal.auto.30b8db8e-86b1-4367-8886-055d3d362718'

let initialized = false

export const initOneSignal = () => {
  if (initialized) return
  initialized = true

  window.OneSignalDeferred = window.OneSignalDeferred || []
  window.OneSignalDeferred.push(async function (OneSignal) {
    try {
      await OneSignal.init({
        appId: APP_ID,
        safari_web_id: SAFARI_WEB_ID,
        notifyButton: {
          enable: true,
          position: 'bottom-left',
          offset: { bottom: '20px', left: '20px' }
        },
        autoPrompt: true,
        welcomeNotification: {
          title: 'YourInsurance',
          message: 'Thanks for subscribing to notifications!'
        }
      })

      const permission = await OneSignal.Notifications.permission
      if (!permission) {
        setTimeout(async () => {
          try {
            await OneSignal.Slidedown.promptPush()
          } catch (_) {
            try {
              await OneSignal.Notifications.requestPermission()
            } catch (_) {}
          }
        }, 3000)
      }
    } catch (err) {
      console.warn('OneSignal init error:', err.message)
    }
  })
}

const getOneSignal = () => window.OneSignal || null

export const identifyOneSignalUser = (userId, email, displayName) => {
  const os = getOneSignal()
  if (!os) return
  try {
    if (userId) os.login(String(userId))
    if (email) os.User.addEmail(email)
    if (displayName) os.User.addTags({ display_name: displayName })
  } catch (_) {}
}

export const logoutOneSignalUser = () => {
  const os = getOneSignal()
  if (!os) return
  try { os.logout() } catch (_) {}
}

export const sendOneSignalOutcome = (outcomeName) => {
  const os = getOneSignal()
  if (!os) return
  try { os.Session.sendOutcome(outcomeName) } catch (_) {}
}

export const sendOneSignalUniqueOutcome = (outcomeName) => {
  const os = getOneSignal()
  if (!os) return
  try { os.Session.sendUniqueOutcome(outcomeName) } catch (_) {}
}

export const setOneSignalTags = (tags) => {
  const os = getOneSignal()
  if (!os) return
  try { os.User.addTags(tags) } catch (_) {}
}
